import React from 'react';

export const getMessageList = (messages: (string | undefined)[]) => {
  const tooltipMessages = messages.filter(Boolean);
  if (tooltipMessages.length === 1) {
    return tooltipMessages[0];
  }
  if (tooltipMessages.length === 0) {
    return null;
  }
  return (
    <ul style={{ paddingLeft: '20px' }}>
      {tooltipMessages.map((m) => (
        <li>{m}</li>
      ))}
    </ul>
  );
};
